export const config = {
  title: "Méndez Roofing & Construction | Quality Roofing Services in Glasgow, KY",
  meta: {
    description:
      "Méndez Roofing & Construction provides reliable, top-quality roofing, siding, and general construction services throughout Glasgow, KY and surrounding areas.",
    keywords: [
      "Méndez Roofing",
      "roofing Glasgow KY",
      "roof repair Glasgow",
      "construction services Kentucky",
      "roof replacement Méndez"
    ],
    author: "Méndez Roofing & Construction",
    canonicalUrl: "https://mendezroofingandconstruction.com/",
  },
  sections: {
    header: {
      businessName: "Méndez Roofing & Construction",
    },
    sectionB: {
      heroTitle: "Méndez Roofing & Construction",
      heroSubtitle: "Top-Quality Roofing and Exterior Solutions in Glasgow, KY",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "2705763685",
      phoneLabel: "(270) 576-3685",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1179153745/photo/multi-ethic-workers-talking-at-construction-site-reviewing-plans.jpg?s=612x612&w=0&k=20&c=i8dsXiHlpTLgju_2tnvkn1C6GtPNGWWoeqm_Zs0zUds=",
      cardData: [
        {
          title: "Residential Roofing",
          description: "From roof repairs to complete replacements, we've got your home covered.",
        },
        {
          title: "Siding & Gutters",
          description: "Enhance your home's appearance and protection with our siding services.",
        },
        {
          title: "General Construction",
          description: "Professional construction solutions tailored to your needs.",
        },
      ],
      description:
        "With years of experience and a dedication to excellence, Méndez Roofing & Construction delivers roofing and construction services you can trust throughout Glasgow, KY.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We offer a wide range of services to improve, restore, and protect your home or building.",
      cards: [
        {
          title: "Roof Installation & Repair",
          description: "High-quality materials and skilled workmanship for durable roofs.",
          imageSrc: "https://media.istockphoto.com/id/2180877420/photo/roofer-worker-installing-new-roof.jpg?s=612x612&w=0&k=20&c=LZ3JKOybYxt3L29pgSAGBnOpfecCoDqbii6A3cFiW5A=",
          imageAlt: "Roof Installation",
        },
        {
          title: "Siding Installation",
          description: "Weather-resistant and energy-efficient siding solutions.",
          imageSrc: "https://media.istockphoto.com/id/2156964884/photo/handyman-process-installing-vinyl-pvc-siding-during-construction-on-a-facade-new-home.jpg?s=612x612&w=0&k=20&c=8bCl06xjEyUiIHWr7pwPOlHzOVtFqcVR2Z0SI5KfLPk=",
          imageAlt: "Siding Installation",
        },
        {
          title: "Custom Construction Projects",
          description: "From additions to renovations, we bring your vision to life.",
          imageSrc: "https://media.istockphoto.com/id/1345384816/photo/construction-industry-and-engineering-in-post-recession-period.jpg?s=612x612&w=0&k=20&c=3sK6hLkePixyVhbjrSDKATOx9cVnbor2d2qASBkUucM=",
          imageAlt: "Construction Projects",
        },
      ],
      otherServicesTitle: "Why Choose Méndez",
      otherServicesList: [
        "Licensed & Insured",
        "Free Estimates",
        "High-Quality Materials",
        "Experienced Team",
        "Customer-Focused Service",
      ],
    },
    sectionD: {
      aboutTitle: "About Méndez Roofing & Construction",
      aboutImage: {
        src: "https://mendezroofingandconstruction.com/wp-content/uploads/2025/08/CONSTRUCTION.jpg",
        alt: "Méndez Roofing Team",
      },
      aboutText: [
        "Méndez Roofing & Construction has built a solid reputation in Glasgow, KY for top-quality roofing, siding, and general construction services.",
        "Our mission is to deliver exceptional workmanship and honest service to homeowners and businesses alike.",
      ],
    },
    sectionE: {
      profileImage: "https://mendezroofingandconstruction.com/wp-content/uploads/2025/08/Logo-8.png",
      profileAlt: "Méndez Roofing Logo",
      businessName: "Méndez Roofing & Construction",
      contact: {
        phone: "2705763685",
        phoneLabel: "(270) 576-3685",
        email: "mendezroofing.17@icloud.com",
        website: "https://mendezroofingandconstruction.com/",
        address: "Glasgow, KY 42141, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Glasgow, KY 42141, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=Glasgow,+KY+42141&output=embed",
    },
  },
};

export default config;
